import React, { useEffect, useState } from 'react';
import Spacer from './Spacer';
import { LayoutOrientations } from '../../globals';

interface IButtonGroupProps
{
	className?: string,
	orientation?: LayoutOrientations,
	label?: string,
	radio?: boolean,
	value?: number,
	onChangeCallback?: (value: number) => void,
}

export default function ButtonGroup(props: React.PropsWithChildren<IButtonGroupProps>)
{
	const orientation = props.orientation !== undefined ? props.orientation : LayoutOrientations.Horizontal;

	const [current, setCurrent] = useState(props.value !== undefined ? props.value : -1);
	
	useEffect(() =>
	{
		setCurrent(props.value ?? -1);
	}, [props.value]);

	useEffect(() =>
	{
		if (props.onChangeCallback)
		{
			props.onChangeCallback(current);
		}
	}, [current]);

	function renderButtons()
	{
		return React.Children.map(props.children, (child, idx) =>
		{
			if (React.isValidElement(child))
			{
				return React.cloneElement<any>(child, {
					key: idx,
					current: props.radio && current === idx,
					onClick: () =>
					{
						if (child.props.onClick)
							child.props.onClick();

						setCurrent(idx);
					},
					className: [
						child.props.className,
						"buttonGroupButton",
						(props.radio && current === idx ? "current" : ""),
					].join(' '),
				});
			}
		});
	}

	return (
		<div data-name={props["data-name"] ?? "button-group-root"}
			className={[
				"buttonGroupRoot",
				(orientation),
				(props.className ? props.className : ""),
			].join(' ')}			
		>
			{
				!props.label ? null :
					<>
						<div className={"buttonGroupLabel"}
							data-name={"button-group-label"}
						>
							{props.label}
						</div>
						<Spacer size={{ x: "10px", y: "8px" }} />
					</>
			}
			{
				renderButtons()
			}
		</div>
	);
}